import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import styles from './skullratio.module.css';
import {numberWithCommas, CDN_URI} from '../common/utilities';
import { useTranslation } from 'react-i18next';

import { createMuiTheme, useTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

/*
    Display Headshot Kills to plain ol' regular kills

    requires 2 paramaters
        headshots (int)
        kills (int)
*/


export default function SkullRatio(props){
    const { t } = useTranslation();

    var gridImgheight = 276;

    const CDN = `${CDN_URI}imgs/profile/`;
    //const CDN = "https://cdn.z8games.com/cfna/templates/assets/imgs/profile/";

    const skullfill = CDN + "graph-headshot-fill.jpg";
    const skullempty = CDN + "graph-headshot-empty.jpg";
    const totalHeadshotsText = t('Total Headshots');

    var divImgheight = AimForTheHead(props.headshots, props.kills);
    
    var ratio = (divImgheight)  ? ((1 - (divImgheight / gridImgheight)) * 100).toFixed(1)  + '%'
                                : ((0 < props.headshots) && (0 < props.kills) && (props.kills <= props.headshots))
                                    ? (getRatio(props.headshots,props.kills)).toFixed(1)  + '%'
                                    : '0.0%';

    return (
        <div className={styles.skullContainer}>
            <Grid item xs={12} sm={12} md={8} lg={12} xl={12} className={styles.fillerkiller}>
                <div className={styles.fillerPicture}>
                    <div className={styles.fillerImg} style={{ display: 'block' }}>
                        <img src={skullfill} alt="killer" style= {{width: '100%'}} />
                    </div>
                    <div className={styles.fillerMask} style={{ height: divImgheight }}>
                        <img src={skullempty} alt="filler" />
                    </div>
                </div>
            </Grid>
            
            <div className={styles.headshots}>
                    {ratio}
                </div>                
                <div className={styles.text}>
                    <div className={styles.statValueFlexContainer}>
                        <h5>{totalHeadshotsText}</h5>
                        <h3>{numberWithCommas(props.headshots)}</h3>
                    </div>
                </div>                
        </div>
    );
}

	function getRatio(shots, kills){
		
        shots = parseInt(shots, 10) + 0;
        kills = parseInt(kills, 10) + 0;		
		
		if(shots >= kills){
			return 100;
		}else{
			return (shots / kills) * 100;
		}
	}


    /**
    //
    //	- find the ratio of headshots to deaths
    //	- change the height of class 'filler-mask' to display the ratio
    //
    **/
    function AimForTheHead(dividend = 0, divisor = 0) {

        dividend = parseInt(dividend, 10) + 0;
        divisor = parseInt(divisor, 10) + 0;

        //console.log('divdend', dividend);
        //console.log('divisor', divisor);

        // or  we will get the official height from Design Team
        var maxHeight = 276;
        //console.log('maxHeight', maxHeight);

        var displayHeight = maxHeight;

        if (0 < dividend && 0 < divisor) {

            // we kinda should do a check to verify that there are more kills than headshot kills (but that is just paranoid [Or is it?] - It is not. It is always necessary.)

            var ratio = (dividend / divisor);

            displayHeight = (ratio >= 1) ? 0 : (maxHeight - (ratio * maxHeight));

            //console.log('displayHeight', displayHeight);
            //$('.filler-mask').height(displayHeight);
        }
        //console.log('-------------------------------------------------------------------------');
        return displayHeight;
    }
